import { Editor } from "@/core/editor"
import { vec2 } from "gl-matrix"

export function toggleAutoZoom(
	editor: Editor,
	options: {
		offset?: vec2
		zoom?: number
	} = {},
) {
	const { offset = [0, 0], zoom = 1 } = options

	if (editor.mainViewport.relativeZoom !== 1) {
		editor.setViewport({
			offsetX: 0,
			offsetY: 0,
			zoom: "fit",
		})
	} else {
		editor.setViewport({
			offsetX: offset[0],
			offsetY: offset[1],
			zoom,
		})
	}
}

export function isFitZoom(editor: Editor) {
	return editor.mainViewport.relativeZoom === 1
}
